import { RouteObject } from "react-router";

import AnaScreen from "./screens/AnasScreen";
import * as screens from "./screens/PlannerV2Screen";
import { PlannerVisitListScreen } from "./screens/PlannerVisitListScreen";

// ## Outline
// /planner/:date
//     /areas/:plannerAreaId
//         /visits/:plannerVisitId
//             /travel-groups/:plannerTravelGroupId
//     /review-schedule
export const plannerV2Routes: RouteObject[] = [
    {
        path: "visits",
        handle: { breadcrumb: "planner:visitListScreen.title" },
        element: <PlannerVisitListScreen />,
    },
    {
        path: "planner/:date",
        element: <screens.PlannerV2Layout />,
        children: [
            {
                index: true,
                element: <screens.PlannerV2AreasScreen />,
            },
            {
                path: "areas/:plannerAreaId",
                children: [
                    {
                        index: true,
                        element: <screens.PlannerV2AreaDetailScreen />,
                    },
                    {
                        path: "visits/:plannerVisitId",
                        children: [
                            {
                                index: true,
                                element: <screens.PlannerV2VisitDetailScreen />,
                            },
                            {
                                path: "travel-groups/:plannerTravelGroupId",
                                element: <screens.PlannerV2RouteScreen />,
                            },
                        ],
                    },
                ],
            },
            {
                path: "review-schedule",
                element: <screens.PlannerV2ReviewPlanScreen />,
            },
        ],
    },
    {
        path: "anaspace",
        element: <AnaScreen />,
    },
];
